/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type HappeningCell_happening$ref: FragmentReference;
declare export opaque type HappeningCell_happening$fragmentType: HappeningCell_happening$ref;
export type HappeningCell_happening = {|
  +id: string,
  +title: string,
  +url: string,
  +imageUrl: ?string,
  +startDate: any,
  +endDate: any,
  +$refType: HappeningCell_happening$ref,
|};
export type HappeningCell_happening$data = HappeningCell_happening;
export type HappeningCell_happening$key = {
  +$data?: HappeningCell_happening$data,
  +$fragmentRefs: HappeningCell_happening$ref,
  ...
};
*/


const node/*: ReaderFragment*/ = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "HappeningCell_happening",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "url",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "imageUrl",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "startDate",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "endDate",
      "storageKey": null
    }
  ],
  "type": "HeroOffer"
};
// prettier-ignore
(node/*: any*/).hash = '124f27a67d706ead498d67d759e07892';

module.exports = node;
